import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=392a8c7d&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=392a8c7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports